export const ZINGER = {
  value: 'zinger',
  title: 'Зингер',
};

export const RED_BRIDGE = {
  value: 'red_bridge',
  title: 'Дом у красного моста',
};
